import AlertModal from 'components/Modal/AlertModal';
import ConfirmModal from 'components/Modal/ConfirmModal';
import GuestSignupModal from 'components/Modal/GuestSignupModal';
import PromptModal from 'components/Modal/PromptModal';
import GoldRefillModal from 'components/Modal/GoldRefillModal';
import SettingsModal from 'components/Modal/SettingsModal';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer, selectIsLoadingAnything } from 'redux/reducers';

const ModalManager = () => {
	const {
		globalPromptModalOptions,
		globalConfirmModalOptions,
		globalGoldRefillModalOptions,
		globalAlertModalOptions,
		guestSignupModalVisible,
		settingsModalVisible,
	} = useSelector((r: RootReducer) => {
		return {
			loading: selectIsLoadingAnything(r),
			sceneLoadError: r.db.sceneLoadError,
			globalPromptModalOptions: r.mode.promptModal,
			globalConfirmModalOptions: r.mode.confirmModal,
			globalGoldRefillModalOptions: r.mode.goldRefillModal,
			globalAlertModalOptions: r.mode.alertModal,
			guestSignupModalVisible: r.mode.guestSignupModalVisible,
			settingsModalVisible: r.mode.settingsModalVisible,
		};
	}, shallowEqual);

	return (
		<>
			{globalPromptModalOptions && <PromptModal options={globalPromptModalOptions} />}
			{globalConfirmModalOptions && <ConfirmModal options={globalConfirmModalOptions} />}
			{globalGoldRefillModalOptions && <GoldRefillModal options={globalGoldRefillModalOptions} />}
			{globalAlertModalOptions && <AlertModal options={globalAlertModalOptions} />}
			{guestSignupModalVisible && <GuestSignupModal />}
			{settingsModalVisible && <SettingsModal />}
		</>
	);
};

export default ModalManager;
